function switchFeatureDevice(btn) {
  const switchEl = btn.closest('.attendance-switch');
  if (!switchEl) return;

  const mobilePreview = document.getElementById('feature-mobile');
  const desktopPreview = document.getElementById('feature-desktop');
  if (!mobilePreview || !desktopPreview) return;

  switchEl.querySelectorAll('.nav-link').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  if (btn.dataset.device === 'mobile') {
    mobilePreview.style.display = '';
    desktopPreview.style.display = 'none';
  } else {
    mobilePreview.style.display = 'none';
    desktopPreview.style.display = '';
  }
}

function switchElsaCapability(btn) {
  const tabs = document.querySelector('.elsa-cap-tabs');
  if (!tabs) return;

  const panelId = btn.dataset.elsaTab;
  if (!panelId) return;

  tabs.querySelectorAll('.elsa-cap-tab').forEach((tab) => {
    const active = tab === btn;
    tab.classList.toggle('active', active);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  document.querySelectorAll('.elsa-cap-panel').forEach((panel) => {
    const match = panel.dataset.elsaPanel === panelId;
    panel.classList.toggle('active', match);
    panel.hidden = !match;
  });
}

// Event delegation survives Turbolinks navigations (no re-bind needed).
document.addEventListener('click', (event) => {
  const deviceBtn = event.target.closest('.attendance-switch .nav-link');
  if (deviceBtn) {
    switchFeatureDevice(deviceBtn);
    return;
  }

  const elsaTab = event.target.closest('.elsa-cap-tab');
  if (elsaTab) {
    switchElsaCapability(elsaTab);
  }
});
